
import { sendRunStartedEvent } from "@/helpers/submit-run";
import { defineComponent } from "vue";

export default defineComponent({
  name: "TimeToggleButton",
  props: {
    style: Object,
  },
  methods: {
    toggleTime(): void {
      if (!this.$store.getters.isTimeRunning && this.$store.state.currentRun.time.timestampRunStart === null) {
        sendRunStartedEvent({ settings: this.$store.state.settings, run: this.$store.state.currentRun });
      }
      this.$store.commit("toggleTime");
    },
  },
});
